"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HikansabumonChiefHyokaRegisterEntry = HikansabumonChiefHyokaRegisterEntry;
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CSwitch = _interopRequireDefault(require("01_core/components/materials/CSwitch"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _ResourceHtml = _interopRequireDefault(require("01_core/components/materials/ResourceHtml"));
var _InputDateTime = _interopRequireDefault(require("01_core/components/select/InputDateTime"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _openSSO = require("01_core/logics/openSSO");
var _coreConditionActions = require("01_core/reducers/coreConditionActions");
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _KansaTgtJigyoBasicInfo = _interopRequireDefault(require("../../common/components/materials/KansaTgtJigyoBasicInfo"));
var _Consts = require("../../common/consts/Consts");
var _kansaProgressActions = require("../../progress/kansaProgressActions");
var _kansaResultActions = require("../kansaResultActions");
var Yup = _interopRequireWildcard(require("yup"));
var _useRHFForm = require("01_core/validation/useRHFForm");
var _validationHelpers = require("01_core/validation/validationHelpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 被監査部門責任者評価登録画面
 */
const StyledReturnButton = (0, _styles.styled)(_CButton.default)({
  margin: '0 0 0 auto'
});
const StyledLeftButton = (0, _styles.styled)(_CButton.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginRight: theme.spacing(2)
  };
});
function HikansabumonChiefHyokaRegisterEntry(props) {
  var _errors$kinyuDate, _errors$kinyuDate2, _errors$kinyushaNm, _errors$hikansabumonC;
  const {
    intl,
    entries,
    kansaInfo,
    kansaTgtJigyoBasicInfo,
    pushSwitchFlg,
    pushFlg,
    mailFlg,
    gyomuCd,
    isProgress,
    btnProps,
    changePusSwitchFlg,
    changePushFlg,
    setEntries,
    setKansaTgtJigyoBasicInfo,
    setMailErrMsg,
    setContent,
    setDirty,
    openInfoBar,
    openConfirm,
    callAPI,
    goProgressMain,
    goMain
  } = props;
  const [procKbnState, setProcKbnState] = (0, _react.useState)(_kansaResultActions.PROC_KBN.REGISTER);
  const didInitValuesRef = (0, _react.useRef)(false);
  const createDefaultValues = (0, _react.useCallback)(() => {
    var _entries$kinyuDate, _entries$kinyushaNm, _entries$hikansabumon;
    return {
      procKbn: _kansaResultActions.PROC_KBN.REGISTER,
      kinyuDate: (_entries$kinyuDate = entries === null || entries === void 0 ? void 0 : entries.kinyuDate) !== null && _entries$kinyuDate !== void 0 ? _entries$kinyuDate : '',
      kinyushaNm: (_entries$kinyushaNm = entries === null || entries === void 0 ? void 0 : entries.kinyushaNm) !== null && _entries$kinyushaNm !== void 0 ? _entries$kinyushaNm : '',
      hikansabumonChiefComment: (_entries$hikansabumon = entries === null || entries === void 0 ? void 0 : entries.hikansabumonChiefComment) !== null && _entries$hikansabumon !== void 0 ? _entries$hikansabumon : ''
    };
  }, [entries]);
  const shape = (0, _react.useMemo)(() => {
    const baseDate = Yup.string().concat((0, _validationHelpers.dateOrEmptyStrict)(intl)).concat((0, _validationHelpers.notFutureDateOrEmpty)(intl));
    return {
      procKbn: Yup.string().oneOf([_kansaResultActions.PROC_KBN.TMP_SAVE, _kansaResultActions.PROC_KBN.REGISTER]).required(),
      kinyuDate: (0, _validationHelpers.requiredWhen)(intl, 'procKbn', v => v === _kansaResultActions.PROC_KBN.REGISTER, baseDate),
      kinyushaNm: (0, _validationHelpers.requiredStringTrimMaxWhen)(intl, 'procKbn', v => v === _kansaResultActions.PROC_KBN.REGISTER, 60),
      hikansabumonChiefComment: (0, _validationHelpers.optionalStringTrimMax)(intl, 500)
    };
  }, [intl]);
  const {
    handleSubmit,
    setValue,
    formState,
    reset
  } = (0, _useRHFForm.useRHFForm)({
    defaultValues: createDefaultValues(),
    shape
  });
  const {
    errors
  } = formState;
  (0, _react.useEffect)(() => {
    window.scrollTo(0, 0);
    changePushFlg(true);
    callAPI(_APIs.HIKANSABUMON_CHIEF_HYOKA_REGISTER_DISP, kansaInfo).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS && response.data) {
        var _response$data$kinyuD, _response$data$kinyus, _response$data$hikans;
        setEntries(response.data);
        reset({
          procKbn: _kansaResultActions.PROC_KBN.REGISTER,
          kinyuDate: (_response$data$kinyuD = response.data.kinyuDate) !== null && _response$data$kinyuD !== void 0 ? _response$data$kinyuD : '',
          kinyushaNm: (_response$data$kinyus = response.data.kinyushaNm) !== null && _response$data$kinyus !== void 0 ? _response$data$kinyus : '',
          hikansabumonChiefComment: (_response$data$hikans = response.data.hikansabumonChiefComment) !== null && _response$data$hikans !== void 0 ? _response$data$hikans : ''
        });
        didInitValuesRef.current = true;
        changePusSwitchFlg(mailFlg && gyomuCd === _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_2 && (response.data.kaizenprogressStsCd === _CodeConsts.CODE.KANSA_KZPRG_STS.CODE_3 || response.data.kaizenprogressStsCd === _CodeConsts.CODE.KANSA_KZPRG_STS.CODE_0));
      } else {
        setEntries(prev => prev);
      }
    }).catch(e => {
      if ((e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.UNMOUNTED || (e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.CALLING) {
        return;
      }
      throw e;
    });
    callAPI(_APIs.KANSA_TGT_JIGYO_BASIC, kansaInfo).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        setKansaTgtJigyoBasicInfo(response.data);
      }
    }).catch(e => {
      if ((e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.UNMOUNTED || (e === null || e === void 0 ? void 0 : e.reason) === _CallAPI.CALLAPI_REJECT_REASON.CALLING) {
        return;
      }
      throw e;
    });
  }, [callAPI, kansaInfo, changePushFlg, setEntries, changePusSwitchFlg, mailFlg, gyomuCd, setKansaTgtJigyoBasicInfo, reset]);
  (0, _react.useEffect)(() => {
    if (!didInitValuesRef.current && entries && Object.keys(entries).length > 0) {
      reset(createDefaultValues());
      didInitValuesRef.current = true;
    }
  }, [entries, reset, createDefaultValues]);
  const setEntryDirty = (0, _react.useCallback)(key => value => {
    props.setEntry(key)(value);
    setValue(key, value, {
      shouldValidate: false,
      shouldDirty: true
    });
    setDirty(true);
  }, [props, setDirty, setValue]);

  // ボタンクリック時（一時保存／登録）
  const onButtonClick = (0, _react.useCallback)(pk => {
    setProcKbnState(pk);
    setValue('procKbn', pk, {
      shouldValidate: true,
      shouldDirty: true
    });
    if (typeof document !== 'undefined' && document.activeElement) {
      try {
        document.activeElement.blur();
      } catch (_unused) {}
    }
  }, [setValue]);

  /**
   * 子画面表示時処理
   */
  const openWindowProcess = (0, _react.useCallback)(nextDispContent => {
    const params = {
      keyKansaTgtNendo: kansaInfo.kansaTgtNendo,
      keyKansaTgtJigyoId: kansaInfo.kansaTgtJigyoId,
      keyDispContent: nextDispContent
    };
    (0, _openSSO.openSubWindowWithParams)('kansa_result', _Consts.CONSTS.COMMON_SUB_WINDOW_KEY, '', '', params).focus();
  }, [kansaInfo]);

  /**
   * 登録実行
   */
  const onRegister = (0, _react.useCallback)(() => {
    const newPushFlg = pushSwitchFlg && pushFlg;
    callAPI(_APIs.HIKANSABUMON_CHIEF_HYOKA_REGISTER, {
      kansaTgtNendo: kansaInfo.kansaTgtNendo,
      kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId,
      kinyuDate: entries.kinyuDate,
      kinyushaNm: entries.kinyushaNm,
      hikansabumonChiefComment: entries.hikansabumonChiefComment,
      hikansabumonChiefHyokaStsCd: _CodeConsts.CODE.KANSA_HYOKA_STS.CODE_3,
      pushFlg: newPushFlg
    }).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        setDirty(false);
        setMailErrMsg(response.message);
        setContent(_kansaResultActions.CONTENTS.HIKANSA_RESULT);
      }
    });
  }, [callAPI, kansaInfo, entries, pushSwitchFlg, pushFlg, setDirty, setMailErrMsg, setContent]);

  /**
   * 一時保存実行
   */
  const onTempSava = (0, _react.useCallback)(() => {
    callAPI(_APIs.HIKANSABUMON_CHIEF_HYOKA_REGISTER_TEMPSAVE, {
      kansaTgtNendo: kansaInfo.kansaTgtNendo,
      kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId,
      kinyuDate: entries.kinyuDate,
      kinyushaNm: entries.kinyushaNm,
      hikansabumonChiefComment: entries.hikansabumonChiefComment,
      hikansabumonChiefHyokaStsCd: _CodeConsts.CODE.KANSA_HYOKA_STS.CODE_2,
      pushFlg: false
    }).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.SUCCESS, intl.formatMessage({
          id: _labelConsts.LABEL.CORE_TEMP_STORE_MESSAGE
        }, {
          0: intl.formatMessage({
            id: _labelConsts.LABEL.KANSA_HIKANSA_HYOKA
          })
        }));
        setDirty(false);
        if (isProgress) {
          // 監査進捗状況の検索結果一覧からの遷移の場合
          goProgressMain(true);
        } else {
          // 監査結果の検索結果一覧からの遷移の場合
          goMain(true);
        }
      } else {
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
      }
    });
  }, [callAPI, kansaInfo, entries, intl, openInfoBar, setDirty, isProgress, goProgressMain, goMain]);

  // 確認ダイアログ
  const onValid = (0, _react.useCallback)(() => {
    const pk = procKbnState;
    if (pk === _kansaResultActions.PROC_KBN.TMP_SAVE) {
      openConfirm(intl.formatMessage({
        id: _labelConsts.LABEL.CORE_CONFIRM
      }), intl.formatMessage({
        id: _labelConsts.LABEL.CORE_TEMPORARILY_SAVED_CONFIRM_MESSAGE
      }), () => {
        onTempSava();
      });
    } else if (pk === _kansaResultActions.PROC_KBN.REGISTER) {
      openConfirm(intl.formatMessage({
        id: _labelConsts.LABEL.CORE_CONFIRM
      }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
        id: _labelConsts.LABEL.CORE_REGISTER_CONFIRM_MESSAGE
      }), pushSwitchFlg && pushFlg && intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_SEND_MAIL_CONFIRM
      }, {
        0: intl.formatMessage({
          id: _labelConsts.LABEL.KANSA_KANSA_BUMON
        })
      })), () => {
        onRegister();
      });
    }
  }, [procKbnState, openConfirm, intl, pushSwitchFlg, pushFlg, onTempSava, onRegister]);
  const onInvalid = (0, _react.useCallback)(() => {
    openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_VALIDATE_MESSAGE
    }));
  }, [openInfoBar, intl]);

  // 戻るボタン
  const returnButton = /*#__PURE__*/_react.default.createElement(StyledReturnButton, {
    onClick: btnProps.onClick(false),
    autoWidth: true,
    negative: true
  }, btnProps.label);

  // 一時保存ボタン
  const tempSaveButton = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    onClick: () => {
      onButtonClick(_kansaResultActions.PROC_KBN.TMP_SAVE);
    },
    submit: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_TEMPORARILY_STORE
  }));

  // 登録ボタン
  const registerButton = /*#__PURE__*/_react.default.createElement(_CButton.default, {
    onClick: () => {
      onButtonClick(_kansaResultActions.PROC_KBN.REGISTER);
    },
    submit: true
  }, intl.formatMessage({
    id: _labelConsts.LABEL.CORE_REGISTER
  }));

  // ボタン生成
  const withTempButton = [returnButton, tempSaveButton, registerButton];
  const noTempButton = [returnButton, registerButton];
  return /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit(onValid, onInvalid)
  }, /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_HIKANSA_HYOKA_REGISTER
    }),
    actions: _CodeConsts.CODE.KANSA_HYOKA_STS.CODE_3 !== entries.hikansabumonChiefHyokaStsCd ? withTempButton : noTempButton
  }, /*#__PURE__*/_react.default.createElement(_material.CardActions, {
    sx: {
      justifyContent: 'flex-start'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    sx: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      xs: 8
    },
    sx: {
      textAlign: 'left'
    }
  }, /*#__PURE__*/_react.default.createElement(StyledLeftButton, {
    onClick: () => openWindowProcess(_kansaResultActions.CONTENTS.RESULT_REFER)
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_RESULT_DETAIL
  })), entries.kaizenprogressStsCd !== _CodeConsts.CODE.KANSA_KZPRG_STS.CODE_0 && /*#__PURE__*/_react.default.createElement(StyledLeftButton, {
    onClick: () => openWindowProcess(_kansaResultActions.CONTENTS.SHITEKI_DETAIL)
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_KAIZEN_PREVIEW
  }))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      xs: 4
    },
    sx: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, returnButton))), /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_KansaTgtJigyoBasicInfo.default, {
    data: kansaTgtJigyoBasicInfo
  }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      xs: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KINYU_DATE
    }),
    required: true
  }, procKbnState === _kansaResultActions.PROC_KBN.REGISTER ? /*#__PURE__*/_react.default.createElement(_InputDateTime.default, {
    value: entries.kinyuDate,
    onChange: setEntryDirty('kinyuDate'),
    dateOnly: true,
    required: true,
    error: !!errors.kinyuDate,
    helperText: (_errors$kinyuDate = errors.kinyuDate) === null || _errors$kinyuDate === void 0 ? void 0 : _errors$kinyuDate.message
  }) : /*#__PURE__*/_react.default.createElement(_InputDateTime.default, {
    value: entries.kinyuDate,
    onChange: setEntryDirty('kinyuDate'),
    dateOnly: true,
    error: !!errors.kinyuDate,
    helperText: (_errors$kinyuDate2 = errors.kinyuDate) === null || _errors$kinyuDate2 === void 0 ? void 0 : _errors$kinyuDate2.message
  })), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KINYUSHA_NM
    }),
    required: true
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: entries.kinyushaNm,
    onChange: setEntryDirty('kinyushaNm'),
    maxLength: 60,
    error: !!errors.kinyushaNm,
    helperText: (_errors$kinyushaNm = errors.kinyushaNm) === null || _errors$kinyushaNm === void 0 ? void 0 : _errors$kinyushaNm.message
  })), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_COMMENT
    })
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: entries.hikansabumonChiefComment,
    onChange: setEntryDirty('hikansabumonChiefComment'),
    multiline: true,
    rows: 7,
    maxLength: 500,
    error: !!errors.hikansabumonChiefComment,
    helperText: (_errors$hikansabumonC = errors.hikansabumonChiefComment) === null || _errors$hikansabumonC === void 0 ? void 0 : _errors$hikansabumonC.message
  })), pushSwitchFlg && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      xs: 8
    },
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_PUSH_COMPLETE_REGISTER
    }),
    required: true,
    indent: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2"
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_PUSH_MAIL
  }, {
    0: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KANSA_BUMON
    })
  }), /*#__PURE__*/_react.default.createElement(_CSwitch.default, {
    checked: pushFlg,
    onChange: changePushFlg,
    required: true,
    shiftLeft: true
  })))))))));
}
const mapStateToProps = state => {
  return {
    entries: state.kansaResult.entries,
    kansaInfo: state.kansaResult.kansaInfo,
    dispContent: state.kansaResult.dispContent,
    subWindow: state.kansaResult.subWindow,
    kansaTgtJigyoBasicInfo: state.kansaResult.kansaTgtJigyoBasicInfo,
    mailFlg: state.coreLoginInfo.mailFlg,
    gyomuCd: state.kansaResult.searchConditions.gyomuCd,
    pushSwitchFlg: state.kansaResult.pushSwitchFlg,
    pushFlg: state.kansaResult.pushFlg,
    isProgress: state.kansaResult.isProgress
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setEntry: key => value => {
      dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](true));
      dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_ENTRY](key, value));
    },
    setEntries: entries => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_ENTRIES](entries)),
    setContent: content => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_CONTENT](content)),
    setKansaInfo: kansaInfo => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_KANSA_INFO](kansaInfo)),
    setKansaTgtJigyoBasicInfo: kansaTgtJigyoBasicInfo => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_KANSA_TGT_JIGYO_BASIC_INFO](kansaTgtJigyoBasicInfo)),
    changePusSwitchFlg: flg => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.CHANGE_PUSH_SWITCH_FLG](flg)),
    changePushFlg: flg => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.CHANGE_PUSH_FLG](flg)),
    setMailErrMsg: mailErrMsg => {
      dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.SET_MAIL_ERR_MSG](mailErrMsg));
    },
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk)),
    closeInfoBar: () => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.CLOSE]()),
    goProgressMain: search => dispatch(_kansaProgressActions.kansaProgressActions[_kansaProgressActions.TYPES.GO_MAIN](search)),
    goMain: search => dispatch(_kansaResultActions.kansaResultActions[_kansaResultActions.TYPES.GO_MAIN](search))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(HikansabumonChiefHyokaRegisterEntry)));